import { createFileRoute } from "@tanstack/react-router";
import { permanentRedirect } from "@/lib/legacyRedirects";

/** Dubblett av /elhandel – pekas om permanent till elhandelsbolagslistan. */
export const Route = createFileRoute("/elbolag/elhandel")({
  beforeLoad: () => permanentRedirect("/elhandel"),
});
